import { apiCall } from '@/lib/api';
import { createMutation, createQuery, useQueryClient } from '@tanstack/solid-query';
import { createUserEmail, deleteUserEmail, getMyUserEmails } from './api';

export const myEmailsKey = ['user-emails', 'mine'] as const;

export const useMyUserEmails = () =>
  createQuery(() => ({
    queryKey: myEmailsKey,
    queryFn: () => apiCall(getMyUserEmails, {}),
  }));

export const useAddUserEmail = () => {
  const qc = useQueryClient();
  return createMutation(() => ({
    mutationFn: (email: string) => apiCall(createUserEmail, { body: { email } }),
    onSuccess: () => qc.invalidateQueries({ queryKey: myEmailsKey }),
  }));
};

export const useDeleteUserEmail = () => {
  const qc = useQueryClient();
  return createMutation(() => ({
    mutationFn: (emailId: string) => apiCall(deleteUserEmail, { params: { emailId } }),
    onSuccess: () => qc.invalidateQueries({ queryKey: myEmailsKey }),
  }));
};
